// Module
var code = "<h1 class=\"heading--isInteriorPageHeading\"> Trouble Making Payments </h1> <p> Don't wait until you fall behind to seek assistance. </p> ";
// Exports
export default code;